import { styled } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { QButton, QTypography } from '@kw/quokka-ui';
import { useOrg } from '../Organization/org-provider';
import { logoutLocal } from '../../auth';

export default function OrgMismatchError() {
  const orgData = useOrg();

  const auth0 = useAuth0();

  const { isAuthenticated, user } = auth0;

  return (
    <StyledDiv>
      {isAuthenticated && (
        <>
          <StyledQTypography>
            Oops! The link you clicked is for a different Q-Scout organization. Log into the correct organization and try the link again.
          </StyledQTypography>
          <StyledUserMessage>
            You&apos;re signed into <b>{orgData?.orgData?.name}</b> as <b>{user.email}</b>
          </StyledUserMessage>
          <StyledQButton
            variant="filled"
            onClick={() => {
              logoutLocal(auth0);
            }}
          >
            Log out
          </StyledQButton>
        </>
      )}
    </StyledDiv>
  );
}

const StyledDiv = styled('div')`
  max-width: 740px;
  margin: 100px auto auto auto;
  padding: 0 20px;
`;

const StyledQTypography = styled(QTypography)`
  font-size: 30px;
  font-weight: 400;
  line-height: 45px;
`;

const StyledUserMessage = styled('p')`
  font-size: 18px;
  line-height: 25px;
  margin: 50px 0 10px 0;
`;

const StyledQButton = styled(QButton)`
  padding: 0 50px;
`;
